import React, {useEffect, useState} from "react";
import {getZipCode} from "../../services/cotizador-service";
import {getImpresionEmisionPDF, getListOfEmissions, postAssert} from "../../services/emission-service";
import {ErrorMessage, Field, Form, Formik} from "formik";
import Swal from "sweetalert2";
import * as ReactDOM from "react-dom";
import moment from "moment";
import {Link, useParams} from "react-router-dom";
import {handleLogout} from "../../services/auth-service";
import * as Yup from 'yup';
import Tooltip from "react-bootstrap/Tooltip";
import {OverlayTrigger} from "react-bootstrap";
import {getListOfReceipts} from "../../services/collection-service";
import {ocuppation, proffesion, Activity, BornEntity, ResidencyType, Countries} from "./utilsQualitasCatalogs";
import {configurationClient} from "./utilsInsuranceConfiguration";
import {Cookies} from "react-cookie";
import {getBankInformation} from "../../services/payment-service";

export default function Emission(props) {
    //Getting params from route
    const {movementId} = useParams();
    const {companyId} = useParams();
    const {cp} = useParams();
    const {paymentId} = useParams();

    let [zipCodeObject, setZipCodeObject] = useState([]);
    let [zipCode, setZipCode] = useState('');
    let [state, setState] = useState('');
    let [delegation, setDelegation] = useState('');
    let [townshipKey, setTownshipKey] = useState('');
    let [townshipSettlementId, setTownshipSettlementId] = useState('');
    const [showEmission, setShowEmission] = useState(true);
    let [emissionFinished, setEmissionFinished] = useState({});
    //at the beginning, in Qualitas, The contractor and the insured are the same person.
    let [isSamePerson, setIsSamePerson] = useState(true);
    let [isAbroadContractor, setIsAbroadContractor] = useState(false);
    let [isAbroadInsurer, setIsAbroadInsurer] = useState(false);
    let [isTaxRegimenContractor, setIsTaxRegimenContractor] = useState(false)
    let [isTaxRegimenInsurer, setIsTaxRegimenInsurer] = useState(false)
    let [isCardCapture, setCardCapture] = useState(false)
    //Card Information
    const currentTime = new Date();
    const year = currentTime.getFullYear();
    const [cvvVisible, setcCvvVisible] = useState(false);
    const visibleCVV = () => {
        setcCvvVisible(!cvvVisible);
    };

    let yearsArray = [];
    for (let i = year; i <= year + 20; i += 1) yearsArray.push(i);
    let monthsArray = [];
    for (let i = 1; i <= 12; i += 1) monthsArray.push(i);
    let [bankInformation, setBackInformation] = useState([])

    //Sign data information
    let[insuranceCompany,setInsuranceCompany] = useState('')
    let [policyNumber, setPolicyNumber] = useState('')
    let [startDate,setStartDate] = useState('')
    let [endDate, setEndDate] = useState('')
    let [contractorName,setContractorName] = useState('')
    let [totalPremium,setTotalPremium] = useState('')


    //---> evento para el manejo de persona extranjera o mexicana en qualitas.
    const handlerChannge = event => {
        if (event.target.value == 1) {
            setIsAbroadContractor(false)
        } else {
            setIsAbroadContractor(true)
        }
    }
    //---> evento para el manejo de persona extranjera o mexicana en qualitas.
    const handlerChanngeInsurer = event => {
        if (event.target.value == 1) {
            setIsAbroadInsurer(false)
        } else {
            setIsAbroadInsurer(true)
        }
    }
    let emissionJson = {};
    let extraData = {};
    let cardData = {};

    const cookies = new Cookies();
    let poolCustomerId = cookies.get('poolCustomerId'); //---> nos ayudar a trabajar con el formulario para no mostrar en Banjercito
    const isAuthenticated = localStorage.getItem("isAuthenticated");

    //Validations for password
    const Schema = Yup.object().shape({});

    //Function to do sign's process
    function emissionFunction(data) {
        console.log(data)
        return Swal.fire({
            title:"Emitiendo",
            text: '(Esto puede tardar algunos segundos)',
            showConfirmButton: false,
            allowOutsideClick: false,
            didOpen() {
                Swal.showLoading(); //Starts loading
                return postAssert(emissionJson).then(data => {
                    setShowEmission(false);
                    setEmissionFinished(data); //Seving the returned data
                    //Setting new data into formikValues.
                    setInsuranceCompany(data.insuranceCompany)
                    setPolicyNumber(data.policyNumber)
                    setStartDate(moment(data.startDate).format('DD/MM/yyyy'))
                    setEndDate(moment(data.endDate).format('DD/MM/yyyy'));
                    setContractorName(data.customer.firstName + ' ' + data.customer.firstSurname + ' ' + data.customer.lastSurname)
                    setTotalPremium('$' + data.premium.totalPremium.toLocaleString('en', {maximumFractionDigits: 2}));
                    if(companyId == 4 && paymentId != 8){
                        window.open(data.urlPayPolicy,'_blank')
                    }
                    Swal.close(); //Stops animation
                }).catch((error) => {
                    setShowEmission(true);
                    Swal.fire({
                        title: 'Ocurrió un error',
                        text: `Request failed: ${error.response.data}`,
                        icon: 'error',
                        iconColor: 'var(--skrSecondary)',
                        backdrop: `rgba(71, 10, 104, .75)`,
                        showCancelButton: true,
                        showConfirmButton: false,
                        cancelButtonColor: 'var(--skrSecondary)',
                        cancelButtonText: 'Ok'
                    });
                    if (error.response.status == 401) {
                        Swal.fire({
                            title: 'La sesión expiró',
                            text: 'Accede nuevamente',
                            icon: 'info',
                            iconColor: 'var(--skrSecondary)',
                            backdrop: `rgba(71, 10, 104, .75)`,
                            showCancelButton: true,
                            showConfirmButton: false,
                            cancelButtonColor: 'var(--skrSecondary)',
                            cancelButtonText: 'Ok'
                        });
                        return handleLogout();
                    }
                });
            }
        })

    }

    useEffect(() => {
        getBankInformation().then(data => {
            setBackInformation(data)
        });
        // Anything in here is fired on component mount.
        if (cp) {
            return getZipCode(cp).then(data => {
                setZipCodeObject(data);
                setZipCode(data[0].zipCode);
                setState(data[0].state);
                setDelegation(data[0].township);
                setTownshipKey(data[0].townshipKey);
                setTownshipSettlementId(data[0].townshipSettlementId);
            });
        } else {
            const element = <p className="text-danger mx-4">No se pudo cargar el formulario adecuadamente, intente hacer
                la emisión de nuevo.</p>;
            ReactDOM.render(element, document.getElementById('noload'));
        }
    }, []);

    return (
        <div className="justify-content-center">
            <Formik initialValues={{
                pass: "",
                confirmPass: "",
                name: "",
                firstSurname: "",
                lastSurname: "",
                curp: "",
                rfc: "",
                sex: "",
                birthdate: "",
                phoneNumber: "",
                email: "",
                street: "",
                externalNumber: "",
                internalNumber: "",
                serialNumber: "",
                engine: "",
                plates: "",
                logNumber: "",
                unitNumber: "",
                colonyCode: zipCode,
                colony: "",
                state: state,
                townShip: delegation,
                insuranceCompany: '',
                policyNumber: '',
                startDate: '',
                endDate: '',
                contractorName: '',
                totalPremium: '',
                taxRegime: false,
                governmental: false,
                officialName: "",
                contractorAbroad: false,
                contractorNational: "",
                contractorEntityBorn: "",
                contractorResidentType: "",
                contractorOccupation: "",
                contractorActivity: "",
                contractorProfession: "",
                contractorDom: "",
                insurerName: "", //Star qualitas field's to record a insurer
                insurerFirstSurname: "",
                insurerLastSurname: "",
                insurerRfc: "",
                insurerCurp: "",
                insurerSex: "",
                insurerBirthdate: "",
                insurerPhoneNumber: "",
                insurerNational: "",
                insurerAbroad: false,
                insurerOccupation: "",
                insurerActivity: "",
                insurerProfession: "",
                insurerEmail: "",
                insurerZipCode: zipCode,
                insurerState: state,
                insurerTownShip: delegation,
                insurerColony: "",
                insurerExternalNumber: "",
                insurerInternalNumber: "",
                insurerTaxRegime: false,
                insurerEntityBorn: "",
                insurerResidentType: "",
                insurerDom: "",
                insurerStreet: "",
                certificateFielContractor: "",
                emailContractor2: "",
                phoneNumberContractor2: "",
                certificateFielInsurer: "",
                insurerPhoneNumber2: "",
                cardType:"",
                bankId:"",
                ownerCardName:"",
                cardNumber:"",
                dateEndMM:"",
                dateEndYY:"",
                cvv:"",
                cardManager:"",
                cardDateCutOff:"",
            }} enableReinitialize
                    validationSchema={Schema}
                    onSubmit={(values,) => {
                        //Preparing JSON for request
                        //En el momento que se tenga que preparar el elemento de la emisión, procedemos a buscar la colonia en el caso necesario
                        //Esto se logra gracias a recorrer el objeto
                        let colonySelected
                        zipCodeObject.map(element => {
                            if (element.description === values.colony) {
                                colonySelected = element.townshipSettlementId
                            }
                        })
                        cardData = {
                            cardType: values.cardType,
                            bankId: values.bankId,
                            ownerCardName: values.ownerCardName,
                            cardNumber: values.cardNumber,
                            dateEndMM: values.dateEndMM,
                            dateEndYY: values.dateEndYY,
                            cvv: values.cvv,
                            cardManager:values.cardManager,
                            cardDateCutOff:values.cardDateCutOff
                        }
                        extraData = {
                            isSamePerson: isSamePerson, //----> Bandera para considerar si son personas diferentes en Qualitas
                            isValidArt: (!configurationClient.includes(poolCustomerId)),
                            contractorCurp: values.curp, //--> Contractor
                            governmental: values.governmental, //--> Contractor
                            officialName: values.officialName, //--> Contractor
                            taxRegime: values.taxRegime, //--> Contractor
                            contractorIdentificationNumber: values.curp, //--> Contractor
                            isContractorAbroad: values.contractorAbroad,
                            contractorNationalBorn: values.contractorNational,
                            contractorEntityBorn: values.contractorEntityBorn,
                            contractorResidentType: values.contractorResidentType,
                            contractorOccupation: values.contractorOccupation,
                            contractorActivity: values.contractorActivity,
                            contractorProfession: values.contractorProfession,
                            contractorDom: values.contractorDom,
                            //----> Insured
                            insurerIdentificationNumber: values.curp, //--> Contractor
                            insurerName: values.insurerName,
                            insurerFirstSurname: values.insurerFirstSurname,
                            insurerLastSurname: values.insurerLastSurname,
                            insurerRfc: values.insurerRfc,
                            insurerCurp: values.insurerCurp,
                            insurerSex: values.insurerSex,
                            insurerBirthdate: values.insurerBirthdate,
                            insurerPhoneNumber: values.insurerPhoneNumber,
                            insurerNationalBorn: values.insurerNational,
                            insurerAbroad: values.insurerAbroad,
                            insurerOccupation: values.insurerOccupation,
                            insurerActivity: values.insurerActivity,
                            insurerProfession: values.insurerProfession,
                            insurerEmail: values.insurerEmail,
                            insurerZipCode: values.insurerZipCode,
                            insurerState: values.insurerState,
                            insurerTownShip: values.insurerTownShip,
                            insurerColony: values.insurerColony,
                            insurerExternalNumber: values.insurerExternalNumber,
                            insurerInternalNumber: values.insurerInternalNumber,
                            insurerTaxRegime: values.insurerTaxRegime,
                            insurerEntityBorn: values.insurerEntityBorn,
                            insurerResidentType: values.insurerResidentType,
                            insurerDom: values.insurerDom,
                            insurerStreet: values.insurerStreet,
                            nationalityContractor: values.nationalityContractor,
                            certificateFielContractor: values.certificateFielContractor,
                            emailContractor2: values.emailContractor2,
                            certificateFielInsurer: values.certificateFielInsurer,
                            insurerPhoneNumber2: values.insurerPhoneNumber2
                        }
                        //En el momento que se tenga que preparar el elemento de la emisión, procedemos a buscar la colonia en el caso necesario
                        emissionJson = {
                            name: values.name,
                            firstSurname: values.firstSurname,
                            lastSurname: values.lastSurname,
                            rfc: values.rfc,
                            sex: values.sex,
                            birthdate: values.birthdate,
                            phoneNumber: values.phoneNumber,
                            email: values.email,
                            street: values.street,
                            externalNumber: values.externalNumber,
                            internalNumber: values.internalNumber,
                            insuranceCompanyId: companyId,
                            serialNumber: values.serialNumber,
                            engine: values.engine,
                            plates: values.plates,
                            logNumber: values.logNumber || '',
                            unitNumber: values.unitNumber || '',
                            quoteMovementId: movementId,
                            township: values.townShip,
                            townshipCode: townshipKey, //del objeto colonia townshipKey
                            colonyCode: colonySelected, //townshipSettlementId, //del objecto colonia townshipSettlementId
                            colony: values.colony, //del objeto colonia description
                            personType: 1,
                            password: values.pass || null,
                            extraData: extraData,
                            cardData: cardData
                        }
                        if(paymentId != 8 && companyId != 4){
                            if(isCardCapture === false){
                                setCardCapture(true)
                            } else {
                                emissionFunction(emissionJson)
                            }
                        } else {
                            emissionFunction(emissionJson)
                        }

                    }}>

                {({values, errors}) => (

                    <Form role="form" name="emissionForm" id="emissionForm"
                          className="form-validation justify-content-center">

                        <div id="noload"></div>

                        {showEmission ?
                            // Si mostramos el formulario para captura de datos
                            <div id="callout-input-needs-type" className="callout callout-success ">
                                {isCardCapture == false ?
                                    <div className="container my-5 p-5 card-border col-11">
                                        {isAuthenticated
                                            ? null
                                            :
                                            <div className="container-fluid mb-4">
                                                <h5 className="montserratMedium">Captura de credenciales </h5>
                                                <div className="row">
                                                    <div className="form-group col-md-6">
                                                        <label htmlFor="pass">Contraseña</label>
                                                        <Field name='pass' type="password"
                                                               className="form-control" id="pass"
                                                               placeholder="Contraseña" autoComplete="off" required/>
                                                        <ErrorMessage name="pass" component={() => (
                                                            <small className="text-danger">{errors.pass} </small>)}/>
                                                    </div>
                                                    <div className="form-group col-md-6">
                                                        <label htmlFor="confirmPass">Confirmar Contraseña</label>
                                                        <Field name='confirmPass' type="password"
                                                               className="form-control" id="confirmPass"
                                                               placeholder="Confirmar contraseña" autoComplete="off"
                                                               required/>
                                                        <ErrorMessage name="confirmPass" component={() => (<small
                                                            className="text-danger">{errors.confirmPass} </small>)}/>
                                                    </div>
                                                </div>
                                            </div>
                                        }

                                        <div className="mt-4">
                                            {
                                                //Manejamos la validación para saber no mostrar el formulario para el cliente de Banjercito
                                                (companyId == 1 && configurationClient.includes(poolCustomerId) === false) ?
                                                    <div className="row m-3">
                                                        <div>
                                                            <input
                                                                type="checkbox"
                                                                id="flagContract"
                                                                name="flagContract"
                                                                value="contract"
                                                                checked={isSamePerson}
                                                                onChange={() => {
                                                                    //Limpiamos campos primero
                                                                    values.insurerName = ""
                                                                    values.insurerFirstSurname = ""
                                                                    values.insurerLastSurname = ""
                                                                    values.insurerRfc = ""
                                                                    values.insurerCurp = ""
                                                                    values.insurerSex = ""
                                                                    values.insurerAbroad = false
                                                                    values.insurerBirthdate = ""
                                                                    values.insurerEntityBorn = ""
                                                                    values.insurerPhoneNumber = ""
                                                                    values.insurerOccupation = ""
                                                                    values.insurerActivity = ""
                                                                    values.insurerProfession = ""
                                                                    values.insurerEmail = ""
                                                                    values.insurerColony = ""
                                                                    values.insurerExternalNumber = ""
                                                                    values.insurerInternalNumber = ""
                                                                    values.insurerTaxRegime = false
                                                                    values.insurerNational = ""
                                                                    values.insurerResidentType = ""
                                                                    values.insurerDom = ""
                                                                    //Pondremos el contrario de la variable
                                                                    setIsSamePerson(!isSamePerson)
                                                                }}
                                                            /> ¿El contratante es la misma persona que el asegurado?
                                                        </div>
                                                    </div>
                                                    : null
                                            }
                                            <div className="container-fluid">
                                                <h5 className="montserratMedium">Datos del contratante </h5>
                                                <div className="row mt-4">
                                                    {/*Tipo de Identificador para qualitas, se valida que no sea el cliente de Banjercito */}
                                                    {companyId == 1 && configurationClient.includes(poolCustomerId) === false ?
                                                        <div className="form-group col-md-3 mt-2">
                                                            <label htmlFor="insurerIdentification">Tipo de
                                                                Identificación</label>
                                                            <Field name="insurerIdentificationType" type="text"
                                                                   className="form-control"
                                                                   id="insurerIdentificationType"
                                                                   placeholder="CURP" disabled/>
                                                        </div>
                                                        : null}

                                                    {/*Tipo de Identificador para qualitas, se valida que no sea el cliente de Banjercito */}
                                                    {companyId == 1 && configurationClient.includes(poolCustomerId) === false ?
                                                        <div className="form-group col-md-3 mt-2">
                                                            <label>Tipo de Persona</label>
                                                            <Field name="insurerTypePerson" type="text"
                                                                   className="form-control"
                                                                   id="insurerTypePerson"
                                                                   placeholder="PERSONA FISICA" disabled/>
                                                        </div>
                                                        : null}

                                                    {/*Name contractor */}
                                                    <div className="form-group col-md-3">
                                                        <label htmlFor="name">Nombre</label>
                                                        <Field name='name' type="text" className="form-control"
                                                               id="name"
                                                               placeholder="Nombre" autoComplete="off" required/>
                                                    </div>

                                                    {/*LastName contractor */}
                                                    <div className="form-group col-md-3">
                                                        <label htmlFor="firstSurname">Apellido Paterno</label>
                                                        <Field name="firstSurname" type="text"
                                                               className="form-control"
                                                               id="firstSurname" placeholder="Apellido Paterno"
                                                               autoComplete="off" required/>
                                                    </div>

                                                    {/*SecoundLastName contractor */}
                                                    <div className="form-group col-md-3">
                                                        <label htmlFor="lastSurname">Apellido Materno</label>
                                                        <Field name="lastSurname" type="text" className="form-control"
                                                               id="lastSurname" placeholder="Apellido Materno"
                                                               autoComplete="off"/>
                                                    </div>

                                                    {/* RFC */}
                                                    <div className="form-group col-md-3">
                                                        <label htmlFor="rfc">RFC</label>
                                                        <Field name="rfc" type="text" className="form-control"
                                                               id="rfc"
                                                               placeholder="RFC" autoComplete="off" type="text"
                                                               style={{textTransform: "uppercase"}} required/>
                                                    </div>

                                                    {/*CURP Campo unicamente usado en Qualitas, se valida que no se muestre en Banjercito*/}
                                                    {companyId == 1 && configurationClient.includes(poolCustomerId) === false ?
                                                        <div className="form-group col-md-3 mt-2">
                                                            <label htmlFor="curp">CURP</label>
                                                            <Field name='curp' type="text" className="form-control"
                                                                   id="curp"
                                                                   placeholder="CURP" autoComplete="off" requiered
                                                                   maxLength="18"
                                                                   minLength="18"/>
                                                        </div>
                                                        : null
                                                    }

                                                    {/* Sex Biology */}
                                                    <div className="form-group col-md-3 mt-2">
                                                        <label htmlFor="sex">Sexo</label>
                                                        <Field as="select" name="sex" id="sex"
                                                               className="form-control" required>
                                                            <option value="" selected disabled>Seleccionar...</option>
                                                            <option value="2">Masculino</option>
                                                            <option value="1">Femenino</option>
                                                        </Field>
                                                    </div>

                                                    {/* Nacionalidad (Qualtias), se valida que no se muestre con banjercito*/}
                                                    {
                                                        companyId == 1 && configurationClient.includes(poolCustomerId) === false ?
                                                            <div className="form-group col-md-3 mt-2">
                                                                <label>Nacionalidad</label>

                                                                <Field as="select" name="nationalityContractor"
                                                                       id="nationalityContractor"
                                                                       className="form-control"
                                                                       onChange={handlerChannge}>
                                                                    <option value="" selected disabled>Seleccionar...
                                                                    </option>
                                                                    <option value="1" id="1">Mexicana</option>
                                                                    <option value="2" id="2">Extranjera</option>
                                                                </Field>
                                                            </div>
                                                            : null
                                                    }


                                                    {/*Pais de Nacimiento (Qualitas), se valida que no se muestre con banjercito */}
                                                    {(companyId == 1 && isAbroadContractor && configurationClient.includes(poolCustomerId) === false)
                                                        ?
                                                        <div className="form-group col-md-3 mt-2">
                                                            <label htmlFor="contractorNational">País de
                                                                Nacimiento</label>
                                                            <Field as="select" name="contractorNational"
                                                                   id="contractorNational"
                                                                   className="form-control" required>
                                                                <option value="" selected disabled>Seleccionar...
                                                                </option>
                                                                {Countries.map(option => (
                                                                    <option selected key={option.id} value={option.id}>
                                                                        {option.value}
                                                                    </option>
                                                                ))}
                                                            </Field>
                                                        </div>
                                                        : null
                                                    }


                                                    {/*Tipo de Residencia(Qualitas), se valida que no se use muestre con banjercito */}
                                                    {(isAbroadContractor && companyId == 1 && configurationClient.includes(poolCustomerId) === false) ?
                                                        <div className="form-group col-md-3 mt-2">
                                                            <label htmlFor="contractorResidentType">Tipo de
                                                                Residencia</label>
                                                            <Field as="select" name="contractorResidentType"
                                                                   id="contractorResidentType" className="form-control"
                                                                   required>
                                                                <option value="" selected disabled>Seleccionar...
                                                                </option>
                                                                {ResidencyType.map(option => (
                                                                    <option selected key={option.id} value={option.id}>
                                                                        {option.value}
                                                                    </option>
                                                                ))}
                                                            </Field>
                                                        </div>
                                                        : null
                                                    }


                                                    {/*Entidad de naciomiento (Qualitas), se valida que no se muestre con banjercito */}
                                                    {(!isAbroadContractor && companyId == 1 && configurationClient.includes(poolCustomerId) === false)
                                                        ? <div className="form-group col-md-3 mt-2">
                                                            <label htmlFor="contractorEntityBorn">Entidad de
                                                                Nacimiento:</label>
                                                            <Field as="select" name="contractorEntityBorn"
                                                                   id="contractorEntityBorn"
                                                                   className="form-control" required>
                                                                <option value="" selected disabled>Seleccionar...
                                                                </option>
                                                                {BornEntity.map(option => (
                                                                    <option selected key={option.id} value={option.id}>
                                                                        {option.value}
                                                                    </option>
                                                                ))}
                                                            </Field>
                                                        </div>
                                                        : null
                                                    }

                                                    {/* Fecha de Nacimiento */}
                                                    <div className="form-group col-md-3 mt-2">
                                                        <label htmlFor="birthdate">Fecha de Nacimiento</label>
                                                        <div className="input-group">
                                                        <span className="input-group-addon"><i
                                                            className="fa fa-calendar"></i></span>
                                                            <Field type="date"
                                                                   name="birthdate"
                                                                   id="birthdate"
                                                                   className="form-control"
                                                                   autoComplete="off" required/>
                                                        </div>
                                                    </div>

                                                    {/*Telefono*/}
                                                    <div className="form-group col-md-3 mt-2">
                                                        <label htmlFor="tel">Teléfono</label>
                                                        <Field name="phoneNumber" type="text"
                                                               className="form-control" id="tel"
                                                               placeholder="Teléfono" autoComplete="off" required
                                                               maxLength="10"
                                                               minLength="10"/>
                                                    </div>
                                                    {/*Srgundo telefono,se valida para no ser mostrado en Banjercito*/}

                                                    {
                                                        (companyId == 1 && configurationClient.includes(poolCustomerId) === false) ?
                                                            <div className="form-group col-md-3 mt-2">
                                                                <label htmlFor="tel">Segundo Teléfono</label>
                                                                <Field name="phoneNumberContractor2" type="text"
                                                                       className="form-control" id="tel"
                                                                       placeholder="Teléfono" autoComplete="off"
                                                                       required
                                                                       maxLength="10"
                                                                       minLength="10"/>
                                                            </div>
                                                            :
                                                            null
                                                    }

                                                    {/*Ocupation Contractor*/}
                                                    {(companyId == 1 && configurationClient.includes(poolCustomerId) === false) ?
                                                        <div className="form-group col-md-3 mt-2">
                                                            <label>Ocupación:</label>
                                                            <Field as="select" name="contractorOccupation"
                                                                   id="contractorOccupation"
                                                                   className="form-control" required>
                                                                <option value="" selected disabled>Seleccionar...
                                                                </option>
                                                                {ocuppation.map(option => (
                                                                    <option selected key={option.id} value={option.id}>
                                                                        {option.value}
                                                                    </option>
                                                                ))}
                                                            </Field>
                                                        </div>
                                                        : null
                                                    }

                                                    {/*Activity Contractor*/}
                                                    {(companyId == 1 && configurationClient.includes(poolCustomerId) === false) ?
                                                        <div className="form-group col-md-3 mt-2">
                                                            <label>Actividad / Giro:</label>
                                                            <Field as="select" name="contractorActivity"
                                                                   id="contractorActivity"
                                                                   className="form-control" required>
                                                                <option value="" selected disabled>Seleccionar...
                                                                </option>
                                                                {Activity.map(option => (
                                                                    <option selected key={option.id} value={option.id}>
                                                                        {option.value}
                                                                    </option>
                                                                ))}
                                                            </Field>
                                                        </div>
                                                        : null
                                                    }

                                                    {/*Profession Contractor*/}
                                                    {(companyId == 1 && configurationClient.includes(poolCustomerId) === false) ?
                                                        <div className="form-group col-md-3 mt-2">
                                                            <label>Profesión:</label>
                                                            <Field as="select" name="contractorProfession"
                                                                   id="contractorProfession"
                                                                   className="form-control" required>
                                                                <option value="" selected disabled>Seleccionar...
                                                                </option>
                                                                {proffesion.map(option => (
                                                                    <option selected key={option.id} value={option.id}>
                                                                        {option.value}
                                                                    </option>
                                                                ))}
                                                            </Field>
                                                        </div>
                                                        : null
                                                    }

                                                    {/*Correo*/}
                                                    <div className="form-group col-md-3 mt-2">
                                                        <label htmlFor="correo">Correo</label>
                                                        <Field name="email" type="text" className="form-control"
                                                               id="correo"
                                                               placeholder="Correo" autoComplete="off" required/>
                                                    </div>

                                                    {/*Correo segundo, solo qualitas, se valida para no se mostrado en qualitas */}
                                                    {
                                                        (companyId == 1 && configurationClient.includes(poolCustomerId) === false) ?
                                                            <div className="form-group col-md-3 mt-2">
                                                                <label htmlFor="correo">Segundo correo</label>
                                                                <Field name="emailContractor2" type="text"
                                                                       className="form-control"
                                                                       id="emailContractor2"
                                                                       placeholder="Correo Electronico"
                                                                       autoComplete="off" required/>
                                                            </div>
                                                            : null
                                                    }

                                                    {/*Código Postal*/}
                                                    <div className="form-group col-md-3 mt-2">
                                                        <label htmlFor="zipCode">Código Postal</label>
                                                        <Field name="colonyCode" type="text" className="form-control"
                                                               id="zipCode" placeholder="Código postal" disabled/>
                                                    </div>

                                                    {/*Estado*/}
                                                    <div className="form-group col-md-3 mt-2">
                                                        <label htmlFor="edo">Estado</label>
                                                        <Field name="state" type="text" className="form-control"
                                                               id="state"
                                                               placeholder="Estado" disabled/>
                                                    </div>
                                                    {/*Estado*/}

                                                    {/*Municipio*/}
                                                    <div className="form-group col-md-3 mt-2">
                                                        <label htmlFor="delMuni">Delegación / Municipio</label>
                                                        <Field name="townShip" type="text" className="form-control"
                                                               id="townShip" placeholder="Delegación / Municipio"
                                                               disabled/>
                                                    </div>
                                                    {/*Municipio*/}

                                                    {/*Colonia*/}
                                                    <div className="form-group col-md-3 mt-2">
                                                        <label htmlFor="col">Colonia</label>

                                                        <Field as="select" name="colony"
                                                               className="form-control form-select" required>
                                                            <option value="" selected disabled>Seleccionar...</option>
                                                            {zipCodeObject.map(option => (
                                                                <option selected key={option.townshipSettlementId}
                                                                        value={option.description}>
                                                                    {option.description}
                                                                </option>)
                                                            )}
                                                        </Field>
                                                    </div>
                                                    {/*Colonia*/}

                                                    {/*Calle*/}
                                                    <div className="form-group col-md-3 mt-2">
                                                        <label htmlFor="calle">Calle</label>
                                                        <Field name="street" type="text"
                                                               className="form-control" id="calle"
                                                               placeholder="Calle" autoComplete="off" required/>
                                                    </div>
                                                    {/*Calle*/}

                                                    {
                                                        (isAbroadContractor && configurationClient.includes(poolCustomerId) === false)
                                                            ?
                                                            <div className="form-group col-md-3 mt-2">
                                                                <label htmlFor="contractorDom">Domicilio
                                                                    Extranjero</label>
                                                                <Field name="contractorDom" type="text"
                                                                       className="form-control" id="contractorDom"
                                                                       placeholder="Domicilio" autoComplete="off"
                                                                       required/>
                                                            </div>
                                                            : null
                                                    }

                                                    {/*NoExterior*/}
                                                    <div className="form-group col-md-3 mt-2">
                                                        <label htmlFor="numExt">No. Exterior</label>
                                                        <Field name="externalNumber" type="text"
                                                               className="form-control"
                                                               id="numExt" placeholder="No. Exterior"
                                                               autoComplete="off" required/>
                                                    </div>
                                                    {/*NoExterior*/}

                                                    {/*NoInterior*/}
                                                    <div className="form-group col-md-3 mt-2">
                                                        <label htmlFor="numInt">No. Interior</label>
                                                        <Field name="internalNumber" type="text"
                                                               className="form-control"
                                                               id="numInt" placeholder="No. Exterior"
                                                               autoComplete="off"/>
                                                    </div>
                                                    {/*NoInterior*/}

                                                    {/*Campo unicamente usado en Qualitas, se valida para no ser usado en bajercito*/}
                                                    {(companyId == 1 && configurationClient.includes(poolCustomerId) === false)
                                                        ? <div className="form-group col-md-3 mt-2">
                                                            <label><Field type="checkbox" name="taxRegime"
                                                                          onClick={() => {
                                                                              setIsTaxRegimenContractor(!isTaxRegimenContractor)
                                                                              values.certificateFielContractor = ""
                                                                          }}/>
                                                                Régimen Fiscal Empresarial</label>
                                                        </div>
                                                        : null}

                                                    {/* Campo para FIEL */}
                                                    {
                                                        (companyId == 1 && isTaxRegimenContractor && configurationClient.includes(poolCustomerId) === false)
                                                            ?
                                                            <div className="form-group col-md-3 mt-2">
                                                                <label>Número certificado FIEL</label>
                                                                <Field name="certificateFielContractor" type="text"
                                                                       className="form-control"
                                                                       id="certificateFielContractor"
                                                                       placeholder="Número certificado FIEL"
                                                                       autoComplete="off"/>
                                                            </div>
                                                            : null
                                                    }

                                                    {/*Campo unicamente usado en Qualitas, se valida para no ser usado en Banjercito*/}
                                                    {(companyId == 1 && configurationClient.includes(poolCustomerId) === false)
                                                        ? <div className="form-group col-md-3 mt-2">
                                                            <label><Field type="checkbox" name="governmental"
                                                                          onClick={() => {
                                                                              values.officialName = ""
                                                                          }}/> ¿El asegurado su cónyuge o algún familiar
                                                                hasta el segundo grado ejerce o ha
                                                                ejercido en los últimos 4 años un cargo superior en el
                                                                gobierno federal municipal o
                                                                estatal o que sea relevante en algún partido político?
                                                            </label>
                                                        </div>
                                                        : null}

                                                    {/*Campo unicamente usado en Qualitas, se valida para no ser usado en Banjercito*/}
                                                    {(companyId == 1 && values.governmental === true && configurationClient.includes(poolCustomerId) === false)
                                                        ?
                                                        <div className="form-group col-md-3 mt-2">
                                                            <label htmlFor="officialName">Nombre del funcionario</label>
                                                            <Field name='officialName' type="text"
                                                                   className="form-control"
                                                                   id="officialName"
                                                                   placeholder="Nombre del Funcionario"
                                                                   autoComplete="off" required/>
                                                        </div>
                                                        : null}
                                                </div>
                                            </div>

                                            {/*container to insured's information to Qualitas, se valida para no ser usado en Banjercito*/}
                                            {(!isSamePerson && companyId == 1 && configurationClient.includes(poolCustomerId) === false)
                                                ? <div className="container-fluid">
                                                    <h5 className="montserratMedium mt-2">Datos del Asegurado </h5>
                                                    <div className="row mt-4">
                                                        {/*Identification Type*/}
                                                        <div className="form-group col-md-3 mt-2">
                                                            <label htmlFor="insurerIdentification">Tipo de
                                                                Identificación</label>
                                                            <Field name="insurerIdentificationType" type="text"
                                                                   className="form-control"
                                                                   id="insurerIdentificationType"
                                                                   placeholder="CURP" disabled/>
                                                        </div>
                                                        {/*Tipo de Identificador para qualitas */} {/*Tipo de Identificador para qualitas */}
                                                        {companyId == 1 ?
                                                            <div className="form-group col-md-3 mt-2">
                                                                <label>Tipo de Persona</label>
                                                                <Field name="insurerTypePerson" type="text"
                                                                       className="form-control"
                                                                       id="insurerTypePerson"
                                                                       placeholder="PERSONA FISICA" disabled/>
                                                            </div>
                                                            : null}
                                                        {/*Insurer Name*/}
                                                        <div className="form-group col-md-3">
                                                            <label htmlFor="insurerName">Nombre</label>
                                                            <Field name='insurerName' type="text"
                                                                   className="form-control"
                                                                   id="insurerName"
                                                                   placeholder="Nombre" autoComplete="off" required/>
                                                        </div>
                                                        {/*FirstSurname Insurer*/}
                                                        <div className="form-group col-md-3">
                                                            <label htmlFor="insurerFirstSurname">Apellido
                                                                Paterno</label>
                                                            <Field name="insurerFirstSurname" type="text"
                                                                   className="form-control"
                                                                   id="insurerFirstSurname"
                                                                   placeholder="Apellido Paterno"
                                                                   autoComplete="off" required/>
                                                        </div>
                                                        {/*LastName Insurer*/}
                                                        <div className="form-group col-md-3">
                                                            <label htmlFor="insurerLastSurname">Apellido Materno</label>
                                                            <Field name="insurerLastSurname" type="text"
                                                                   className="form-control"
                                                                   id="insurerLastSurname"
                                                                   placeholder="Apellido Materno"
                                                                   autoComplete="off"/>
                                                        </div>
                                                        {/*RFC Insurer*/}
                                                        <div className="form-group col-md-3">
                                                            <label htmlFor="insurerRfc">RFC</label>
                                                            <Field name="insurerRfc" type="text"
                                                                   className="form-control"
                                                                   id="insurerRfc"
                                                                   placeholder="RFC" autoComplete="off" type="text"
                                                                   style={{textTransform: "uppercase"}} required/>
                                                        </div>
                                                        {/*CURP Insurer*/}
                                                        <div className="form-group col-md-3 mt-2">
                                                            <label htmlFor="insurerCurp">CURP</label>
                                                            <Field name='insurerCurp' type="text"
                                                                   className="form-control"
                                                                   id="insurerCurp"
                                                                   placeholder="CURP" autoComplete="off" requiered
                                                                   maxLength="18"
                                                                   minLength="18"/>
                                                        </div>
                                                        {/*Biology sex*/}
                                                        <div className="form-group col-md-3 mt-2">
                                                            <label htmlFor="insurerSex">Sexo</label>
                                                            <Field as="select" name="insurerSex" id="insurerSex"
                                                                   className="form-control" required>
                                                                <option value="" selected disabled>Seleccionar...
                                                                </option>
                                                                <option value="2">Masculino</option>
                                                                <option value="1">Femenino</option>
                                                            </Field>
                                                        </div>
                                                        {/*National Insurer*/}
                                                        <div className="form-group col-md-3 mt-2">
                                                            <label>Nacionalidad</label>

                                                            <Field as="select" name="nationalityContractor"
                                                                   id="nationalityContractor" className="form-control"
                                                                   onChange={handlerChanngeInsurer}>
                                                                <option value="" selected disabled>Seleccionar...
                                                                </option>
                                                                <option value="1" id="1">Mexicana</option>
                                                                <option value="2" id="2">Extranjera</option>
                                                            </Field>
                                                        </div>
                                                        {/* País de Origen*/}
                                                        {isAbroadInsurer ?
                                                            <div className="form-group col-md-3 mt-2">
                                                                <label htmlFor="insurerNational">País de Origen</label>
                                                                <Field as="select" name="insurerNational"
                                                                       id="insurerNational"
                                                                       className="form-control" required>
                                                                    <option value="" selected disabled>Seleccionar...
                                                                    </option>
                                                                    {Countries.map(option => (
                                                                        <option selected key={option.id}
                                                                                value={option.id}>
                                                                            {option.value}
                                                                        </option>
                                                                    ))}
                                                                </Field>
                                                            </div>
                                                            : null
                                                        }
                                                        {/* Entidad de nacimiento*/}
                                                        {
                                                            !isAbroadInsurer ?
                                                                <div className="form-group col-md-3 mt-2">
                                                                    <label>Entidad de Nacimiento:</label>
                                                                    <Field as="select" name="insurerEntityBorn"
                                                                           id="insurerEntityBorn"
                                                                           className="form-control" required>
                                                                        <option value="" selected
                                                                                disabled>Seleccionar...
                                                                        </option>
                                                                        {BornEntity.map(option => (
                                                                            <option selected key={option.id}
                                                                                    value={option.id}>
                                                                                {option.value}
                                                                            </option>
                                                                        ))}
                                                                    </Field>
                                                                </div>
                                                                : null
                                                        }

                                                        {/*Birthdate Insurer*/}
                                                        <div className="form-group col-md-3 mt-2">
                                                            <label htmlFor="insurerBirthdate">Fecha de
                                                                Nacimiento</label>
                                                            <div className="input-group">
                                                                <span className="input-group-addon"><i
                                                                    className="fa fa-calendar"></i></span>
                                                                <Field type="date"
                                                                       name="insurerBirthdate"
                                                                       id="insurerBirthdate"
                                                                       className="form-control"
                                                                       autoComplete="off" required/>
                                                            </div>
                                                        </div>
                                                        {/*Validate if is stranger*/}
                                                        {
                                                            isAbroadInsurer
                                                                ?
                                                                <div className="form-group col-md-3 mt-2">
                                                                    <label htmlFor="insurerResidencialType">Tipo de
                                                                        Residencia</label>
                                                                    <Field as="select" name="insurerResidentType"
                                                                           id="insurerResidentType"
                                                                           className="form-control" required>
                                                                        <option value="" selected
                                                                                disabled>Seleccionar...
                                                                        </option>
                                                                        {ResidencyType.map(option => (
                                                                            <option selected key={option.id}
                                                                                    value={option.id}>
                                                                                {option.value}
                                                                            </option>
                                                                        ))}
                                                                    </Field>
                                                                </div>
                                                                :
                                                                null
                                                        }
                                                        {/*Telephone Insurer*/}
                                                        <div className="form-group col-md-3 mt-2">
                                                            <label htmlFor="insurerTel">Teléfono</label>
                                                            <Field name="insurerPhoneNumber" type="text"
                                                                   className="form-control" id="insurerTel"
                                                                   placeholder="Teléfono" autoComplete="off" required
                                                                   maxLength="10"
                                                                   minLength="10"/>
                                                        </div>
                                                        {/*Segundo numero*/}
                                                        <div className="form-group col-md-3 mt-2">
                                                            <label>Segundo Teléfono</label>
                                                            <Field name="insurerPhoneNumber2" type="text"
                                                                   className="form-control" id="insurerTel2"
                                                                   placeholder="Teléfono" autoComplete="off" required
                                                                   maxLength="10"
                                                                   minLength="10"/>
                                                        </div>
                                                        {/*Ocupation Insurer*/}
                                                        <div className="form-group col-md-3 mt-2">
                                                            <label>Ocupación:</label>
                                                            <Field as="select" name="insurerOccupation"
                                                                   id="insurerOccupation"
                                                                   className="form-control" required>
                                                                <option value="" selected disabled>Seleccionar...
                                                                </option>
                                                                {ocuppation.map(option => (
                                                                    <option selected key={option.id} value={option.id}>
                                                                        {option.value}
                                                                    </option>
                                                                ))}
                                                            </Field>
                                                        </div>
                                                        {/*Activity Insurer*/}
                                                        <div className="form-group col-md-3 mt-2">
                                                            <label>Actividad / Giro:</label>
                                                            <Field as="select" name="insurerActivity"
                                                                   id="insurerActivity"
                                                                   className="form-control" required>
                                                                <option value="" selected disabled>Seleccionar...
                                                                </option>
                                                                {Activity.map(option => (
                                                                    <option selected key={option.id} value={option.id}>
                                                                        {option.value}
                                                                    </option>
                                                                ))}
                                                            </Field>
                                                        </div>
                                                        {/*Profession Insurer*/}
                                                        <div className="form-group col-md-3 mt-2">
                                                            <label>Profesión:</label>
                                                            <Field as="select" name="insurerProfession"
                                                                   id="insurerProfession"
                                                                   className="form-control" required>
                                                                <option value="" selected disabled>Seleccionar...
                                                                </option>
                                                                {proffesion.map(option => (
                                                                    <option selected key={option.id} value={option.id}>
                                                                        {option.value}
                                                                    </option>
                                                                ))}
                                                            </Field>
                                                        </div>
                                                        {/*Email Insurer*/}
                                                        <div className="form-group col-md-3 mt-2">
                                                            <label htmlFor="correo">Correo</label>
                                                            <Field name="insurerEmail" type="text"
                                                                   className="form-control"
                                                                   id="insurerEmai"
                                                                   placeholder="Correo" autoComplete="off" required/>
                                                        </div>
                                                        {/* Segundo Correo */}
                                                        <div className="form-group col-md-3 mt-2">
                                                            <label>Segundo Correo:</label>
                                                            <Field name="insurerSecoundEmail" type="text"
                                                                   className="form-control"
                                                                   id="insurerSecoundEmail"
                                                                   placeholder="Correo" autoComplete="off" required/>
                                                        </div>

                                                        {/*ZipCode Insurer*/}
                                                        <div className="form-group col-md-3 mt-2">
                                                            <label htmlFor="insurerZipCode">Código Postal</label>
                                                            <Field name="insurerZipCode" type="text"
                                                                   className="form-control"
                                                                   id="insurerZipCode" placeholder="Código postal"
                                                                   disabled/>
                                                        </div>
                                                        {/*State code Insurer*/}
                                                        <div className="form-group col-md-3 mt-2">
                                                            <label htmlFor="edo">Estado</label>
                                                            <Field name="insurerState" type="text"
                                                                   className="form-control"
                                                                   id="insurerState"
                                                                   placeholder="Estado" disabled/>
                                                        </div>
                                                        {/*TownShip Insurer*/}
                                                        <div className="form-group col-md-3 mt-2">
                                                            <label htmlFor="delMuni">Delegación / Municipio</label>
                                                            <Field name="insurerTownShip" type="text"
                                                                   className="form-control"
                                                                   id="insurerTownShip"
                                                                   placeholder="Delegación / Municipio"
                                                                   disabled/>
                                                        </div>
                                                        {/*Colony code Insurer*/}
                                                        <div className="form-group col-md-3 mt-2">
                                                            <label htmlFor="col">Colonia</label>

                                                            <Field as="select" name="insurerColony"
                                                                   className="form-control form-select" required>
                                                                <option value="" selected disabled>Seleccionar...
                                                                </option>
                                                                {zipCodeObject.map(option => (
                                                                    <option selected key={option.townshipSettlementId}
                                                                            value={option.description}>
                                                                        {option.description}
                                                                    </option>)
                                                                )}
                                                            </Field>
                                                        </div>
                                                        <div className="form-group col-md-3 mt-2">
                                                            <label htmlFor="calle">Calle</label>
                                                            <Field name="insurerStreet" type="text"
                                                                   className="form-control" id="insurerStreet"
                                                                   placeholder="Calle" autoComplete="off" required/>
                                                        </div>

                                                        {
                                                            //Domicilio extranjero
                                                            isAbroadInsurer ?
                                                                <div className="form-group col-md-3 mt-2">
                                                                    <label htmlFor="insurerDom">Domicilio
                                                                        Extranjero</label>
                                                                    <Field name="insurerDom" type="text"
                                                                           className="form-control" id="insurerDom"
                                                                           placeholder="Domicilio" autoComplete="off"
                                                                           required/>
                                                                </div>
                                                                : null
                                                        }

                                                        {/*External Number Insurer*/}
                                                        <div className="form-group col-md-3 mt-2">
                                                            <label htmlFor="insurerNumExt">No. Exterior</label>
                                                            <Field name="insurerExternalNumber" type="text"
                                                                   className="form-control"
                                                                   id="insurerNumExt" placeholder="No. Exterior"
                                                                   autoComplete="off" required/>
                                                        </div>
                                                        {/*Internal Number Insurer*/}
                                                        <div className="form-group col-md-3 mt-2">
                                                            <label htmlFor="insurerNumInt">No. Interior</label>
                                                            <Field name="insurerInternalNumber" type="text"
                                                                   className="form-control"
                                                                   id="insurerNumInt" placeholder="No. Exterior"
                                                                   autoComplete="off"/>
                                                        </div>
                                                        {/*Fiscal Tax Insurer*/}
                                                        <div className="form-group col-md-3 mt-3">
                                                            <label><Field type="checkbox" name="insurerTaxRegime"
                                                                          onClick={() => {
                                                                              setIsTaxRegimenInsurer(!isTaxRegimenInsurer)
                                                                              values.certificateFielInsurer = ""
                                                                          }
                                                                          }/>Régimen fiscal Empresarial</label>
                                                        </div>

                                                        {
                                                            isTaxRegimenInsurer ?
                                                                <div className="form-group col-md-3 mt-2">
                                                                    <label>Número certificado FIEL</label>
                                                                    <Field name="certificateFielInsurer" type="text"
                                                                           className="form-control"
                                                                           id="certificateFielInsurer"
                                                                           placeholder="Número certificado FIEL"
                                                                           autoComplete="off"/>
                                                                </div>
                                                                :
                                                                null
                                                        }
                                                    </div>
                                                </div>
                                                : null
                                            }
                                            {/*container to insured's information to Qualitas*/}
                                        </div>
                                        <div className="mt-4">
                                            <div className="container-fluid">
                                                <h5 className="montserratMedium">Datos del vehículo</h5>
                                                <div className="row mt-4">
                                                    <div className="form-group col-md-3">
                                                        <label htmlFor="numSerie">No. Serie</label>
                                                        <Field name="serialNumber" type="text"
                                                               className="form-control"
                                                               id="numSerie" placeholder="No. de Serie"
                                                               autoComplete="off"

                                                               required/>
                                                    </div>
                                                    <div className="form-group col-md-3">
                                                        <label htmlFor="motor">No. Motor</label>
                                                        <Field name="engine" type="text" className="form-control"
                                                               id="motor" placeholder="No. de Motor"
                                                               autoComplete="off"/>
                                                    </div>
                                                    <div className="form-group col-md-3">
                                                        <label htmlFor="placas">Placas</label>
                                                        <Field name="plates" type="text" className="form-control"
                                                               id="placas" placeholder="Placas" autoComplete="off"/>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    :
                                    <div>
                                        <div className="container my-5 p-5 card-border col-11">
                                            <div className="col">
                                                <h3>Información de la tarjeta</h3>
                                                {/*Primer elemento corresponderá al tipo de tajerta, Credito o Debito*/}
                                                <div>
                                                    <div className="form-group">
                                                        <Field as ="select" name="cardManager" id="cardManager" className="form-control" requiered>
                                                            <option value="" selected disabled>Tipo de Tarjeta</option>
                                                            <option key="1" value="1">Tarjeta de debito</option>
                                                            <option key="2" value="2">Tarjeta de credito</option>
                                                            <option key="3" value="3">American Express</option>
                                                        </Field>
                                                    </div>
                                                </div>

                                                <div>
                                                    <div className="form-group mt-2">
                                                        <Field as ="select" name="cardType" id="cardType" className="form-control" required>
                                                            <option value="" selected disabled>Operador de Tarjeta</option>
                                                            <option key="1" value="1">American Express</option>
                                                            <option key="3" value="3">Mastercard</option>
                                                            <option key="4" value="4">Visa</option>
                                                        </Field>
                                                    </div>
                                                </div>

                                                <div>
                                                    <div className="form-group mt-2">
                                                        <Field as="select" name="bankId" id="bankId"  className="form-control" required>
                                                            <option value="" selected disabled>Nombre del Banco</option>
                                                            {bankInformation.map(element => (
                                                                    <option key={element.idBank} value={element.idBank}>
                                                                        {element.description}
                                                                    </option>
                                                            ))}
                                                        </Field>
                                                    </div>
                                                </div>

                                                <div className="form-group mt-2">
                                                    <label htmlFor="cardDateCutOff">Fecha de Corte</label>
                                                    <div className="input-group">
                                                        <span className="input-group-addon"><i
                                                            className="fa fa-calendar"></i></span>
                                                        <Field type="date"
                                                               name="cardDateCutOff"
                                                               id="cardDateCutOff"
                                                               className="form-control"
                                                               autoComplete="off" required/>
                                                    </div>
                                                </div>

                                                <div className="form-group mt-2">
                                                    <Field name="ownerCardName" id="ownerCardName" type="text" className="form-control" placeholder="Nombre del titular de la tarjeta" required/>
                                                </div>
                                                <div className="form-group mt-2">
                                                    <Field name='cardNumber' id="cardNumber" type="text" className="form-control" autoComplete="off" placeholder="Número de tarjeta" required/>
                                                </div>
                                                <div className="row">
                                                    <div className="col-sm-12 col-md-6">
                                                        <div className="form-group mt-2">
                                                            <Field as="select" name="dateEndMM" id="dateEndMM"
                                                                    className="form-control form-select"
                                                                    placeholder="MM / YY" required>
                                                                <option value="" selected disabled>
                                                                    Mes de vencimiento
                                                                </option>
                                                                {monthsArray.map(option => (
                                                                    <option key={option} value={option}>
                                                                        {option.toLocaleString('en-US', {
                                                                            minimumIntegerDigits: 2,
                                                                            useGrouping: false
                                                                        })}
                                                                    </option>))}
                                                            </Field>
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-12 col-md-6">
                                                        <div className="form-group mt-2">
                                                            <Field as="select" name="dateEndYY" id="dateEndYY"
                                                                    className="form-control form-select"
                                                                    placeholder="MM / YY" required>
                                                                <option value="" selected disabled>
                                                                    Año de vencimiento
                                                                </option>
                                                                {yearsArray.map(option => (
                                                                    <option key={option} value={option}>
                                                                        {option}
                                                                    </option>))}
                                                            </Field>
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-12 col-md-6">
                                                        <div className="form-group mt-2">
                                                            <div className="input-group mb-2">
                                                                <Field name="cvv" id="cvv"
                                                                       type={cvvVisible ? "text" : "password"}
                                                                       maxLength="4" minLength="3"
                                                                       min="3" max="4" pattern="^[0-9]+$"
                                                                       className="form-control border-end-0"
                                                                       placeholder="CVV / CVC" required/>
                                                                <div className="input-group-prepend">
                                                                    <span data-toggle="tooltip" title="Ver o esconder CVV/CVC" className="input-group-text bg-transparent border-start-0" role="button"
                                                                          onClick={visibleCVV}><i className="bi bi-eye-fill text-secondary"></i></span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                                <div className="container my-5 b-5 text-end col-11">
                                    <div className="row">
                                        <h5 className="montserratMedium">Emite tu seguro
                                            {companyId == 4 ? (" con Chubb") : null}
                                            {companyId == 5 ? (" con Hdi Seguros") : null}
                                            {companyId == 7 ? (" con GNP") : null}
                                            {companyId == 3 ? (" con Mapfre") : null}
                                            {companyId == 2 ? (" con Afirme") : null}
                                            {companyId == 1 ? (" con Quálitas") : null}
                                        </h5>
                                    </div>
                                    <div className="row mt-2 text-end">
                                        <div className="col-8">
                                        </div>
                                        <div className="col-4 text-end">
                                            <button type="submit" className="btn btn-submit">¡Quiero mi seguro!
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            :
                            // Si ya emitimos, procedemos a mostrar la información de la póliza emitida
                            <div>
                                <div className="col-md-4 col-md-offset-3 m-auto my-5">
                                    <h4>Emitido <i className="bi bi-check2-square"></i></h4>
                                    <div className="panel list-group text-center card-border">
                                        <div className="list-group-item">
                                            <label>
                                                <strong><u><i className="bi bi-building"></i> Compañía: </u>
                                                </strong>
                                            </label>
                                            <h6 className="mt-1">{insuranceCompany}</h6>
                                        </div>
                                        <div className="list-group-item">
                                            <label><strong>
                                                <u><i className="bi bi-file-earmark-binary"></i> No.
                                                    Póliza: </u>
                                            </strong></label>
                                            <h6 className="mt-1">{policyNumber}</h6>
                                        </div>
                                        <div className="list-group-item">
                                            <label><strong><u>
                                                <i className="bi bi-calendar2-check"></i> Fecha de
                                                inicio: </u>
                                            </strong></label>
                                            <h6 className="mt-1">{startDate}</h6>
                                        </div>
                                        <div className="list-group-item">
                                            <label><strong><u><i className="bi bi-calendar-x"></i> Fecha de
                                                término:
                                            </u></strong></label>
                                            <h6 className="mt-1">{endDate}</h6>
                                        </div>
                                        <div className="list-group-item">
                                            <label><strong><u><i className="bi bi-person"></i> Contratante:
                                            </u></strong></label>
                                            <h6 className="mt-1">{contractorName}</h6>
                                        </div>
                                        <div className="list-group-item">
                                            <label><strong><u><i className="bi bi-currency-dollar"></i> Prima
                                                total:
                                            </u></strong></label>
                                            <h6 className="mt-1">{totalPremium}</h6>
                                        </div>
                                        <div className="list-group-item mt-2">
                                            {/* Contiene los botones para realizar los movimientos */}
                                            <div className="row">
                                                <div className="col-lg-4 col-sm-12 mt-1">
                                                    {isAuthenticated ?
                                                        <Link to="/cotizadorAdministrador" className="m-auto">
                                                            <button type="button" data-toggle="tooltip"
                                                                    title="Regresar a cotizador"
                                                                    className="btn btn-skr-secondary btn-sm">
                                                                <i className="bi-arrow-return-left"></i> Cotizador
                                                            </button>
                                                        </Link> :

                                                        <Link to="/cotizador" className="m-auto">
                                                            <button type="button"
                                                                    className="btn btn-skr-secondary btn-sm">
                                                                <i className="bi-arrow-return-left"></i> Cotizador
                                                            </button>
                                                        </Link>}
                                                </div>
                                                {/* Contiene los botones para realizar el pago */}
                                                <div className="col-lg-4 col-sm-12 mt-1"
                                                     hidden={props.userPermissions[3] !== 1}>
                                                    <button type="button" data-toggle="tooltip"
                                                            title="Pagar"
                                                            className="btn btn-skr-secondary btn-sm"
                                                        //Llamamos a la consulta para obtener los recibos de una póliza
                                                            onClick={() => {
                                                                //Esta funcionalidad es un callBack,se usa cuando el evento tienen multiples lineas
                                                                let workOrderId;
                                                                getListOfEmissions().then(data => {
                                                                    data.map(element => {
                                                                        if (element.policyNumber === values.policyNumber) {
                                                                            workOrderId = element.workOrderId
                                                                            getListOfReceipts(workOrderId).then(receipt => {
                                                                                //Obtenemos el valor del recibo en la posicio 0,
                                                                                let receiptId = receipt[0].receiptId;
                                                                                console.log(receiptId);

                                                                                window.location = `/#/pasarelaPago/${receiptId}`
                                                                            })
                                                                            //workOrderPolicy = element.workOrderId;
                                                                            //workOrderIdEmission = workOrderPolicy
                                                                            //toggleModalReceipts()
                                                                        }
                                                                    })
                                                                }).catch()
                                                            }}
                                                    >
                                                        <i className="bi-credit-card-2-back-fill"></i> Pagar
                                                    </button>
                                                </div>

                                                <div className="col-lg-4 col-sm-12 mt-1"
                                                     hidden={props.userPermissions[1] !== 1}>
                                                    <OverlayTrigger placement="top"
                                                                    overlay={<Tooltip>Descargar PDF</Tooltip>}>
                                                        <button type="button" onClick={() => {
                                                            Swal.fire({
                                                                title: 'Descargando PDF...',
                                                                showConfirmButton: false,
                                                                allowOutsideClick: false,
                                                                didOpen: () => {
                                                                    Swal.showLoading();
                                                                    return getImpresionEmisionPDF(emissionFinished.movementId).then(data => {
                                                                        const url = window.URL.createObjectURL(new Blob([data]));
                                                                        const link = document.createElement('a');
                                                                        link.href = url;
                                                                        link.setAttribute('download', emissionFinished.policyNumber + '.pdf');
                                                                        document.body.appendChild(link);
                                                                        link.click();
                                                                    }).then(() => Swal.close()).catch(error => {
                                                                        Swal.fire({
                                                                            title: 'Ocurrió un error',
                                                                            text: `No se pudo descargar el PDF`,
                                                                            icon: 'error',
                                                                            iconColor: 'var(--skrSecondary)',
                                                                            backdrop: `rgba(71, 10, 104, .75)`,
                                                                            showCancelButton: true,
                                                                            showConfirmButton: false,
                                                                            cancelButtonColor: 'var(--skrSecondary)',
                                                                            cancelButtonText: 'Ok'
                                                                        });
                                                                        if (error.response.status == 401) {
                                                                            Swal.fire({
                                                                                title: 'La sesión expiró',
                                                                                text: 'Accede nuevamente',
                                                                                icon: 'info',
                                                                                iconColor: 'var(--skrSecondary)',
                                                                                backdrop: `rgba(71, 10, 104, .75)`,
                                                                                showCancelButton: true,
                                                                                showConfirmButton: false,
                                                                                cancelButtonColor: 'var(--skrSecondary)',
                                                                                cancelButtonText: 'Ok'
                                                                            });
                                                                            return handleLogout();
                                                                        }
                                                                    })
                                                                }
                                                            })

                                                        }} className="btn btn-skr-secondary btn-sm">
                                                            <i className="bi-file-pdf"></i> PDF
                                                        </button>
                                                    </OverlayTrigger>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>}

                    </Form>)}
            </Formik>
        </div>
    )
}